import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useRef } from 'react';
import { Form } from '../Form/Form.js';
import { MultilingualForm } from '../Form/MultilingualForm.js';
import { i18n } from '../../i18n/translate.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
import Button from '../../core/components/Button/component.js';
import { Modal } from '../../core/components/Modal/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
import { Typography } from '../../core/components/Typography/component.js';

var ModalForm = function ModalForm(props) {
  var _formRef$current2;

  var activeLanguage = props.activeLanguage,
      cancelButtonText = props.cancelButtonText,
      className = props.className,
      children = props.children,
      _props$container = props.container,
      container = _props$container === void 0 ? undefined : _props$container,
      data = props.data,
      _props$disableButtons = props.disableButtons,
      disableButtons = _props$disableButtons === void 0 ? false : _props$disableButtons,
      languages = props.languages,
      onClose = props.onClose,
      _props$saveButton = props.saveButton,
      saveButton = _props$saveButton === void 0 ? true : _props$saveButton,
      _props$saveButtonDisa = props.saveButtonDisabled,
      saveButtonDisabled = _props$saveButtonDisa === void 0 ? false : _props$saveButtonDisa,
      saveButtonText = props.saveButtonText,
      _props$saveButtonIcon = props.saveButtonIcon,
      saveButtonIcon = _props$saveButtonIcon === void 0 ? null : _props$saveButtonIcon,
      show = props.show,
      _props$size = props.size,
      size = _props$size === void 0 ? 'lg' : _props$size,
      title = props.title,
      _props$skipCancelConf = props.skipCancelConfirmation,
      skipCancelConfirmation = _props$skipCancelConf === void 0 ? false : _props$skipCancelConf;
  var saveAndAddButton = props.saveAndAddButton !== undefined ? props.saveAndAddButton : !(data !== null && data !== void 0 && data.id);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      triggerCancel = _useState2[0],
      setTriggerCancel = _useState2[1];

  var formRef = useRef(); // This should update when Form is converted.

  var buildForm = function buildForm() {
    if (data) {
      var commonProps = {
        onCancel: onModalCancel,
        onCancelClose: onCancelClose,
        triggerCancel: triggerCancel,
        skipCancelConfirmation: skipCancelConfirmation,
        activeLanguage: activeLanguage
      };

      if (languages) {
        return /*#__PURE__*/React.createElement(MultilingualForm, _extends({}, props, commonProps, {
          formRef: formRef,
          hasFormButtons: false
        }), children);
      } else {
        return /*#__PURE__*/React.createElement(Form, _extends({}, props, commonProps, {
          ref: formRef,
          hasFormButtons: false
        }), children);
      }
    }
  };

  var onCancelClose = function onCancelClose() {
    return setTriggerCancel(false);
  };

  var onModalCancel = function onModalCancel() {
    setTriggerCancel(false);

    if (onClose) {
      onClose();
    }
  };

  var onHide = function onHide() {
    return setTriggerCancel(true);
  };

  var getModalClasses = function getModalClasses() {
    return _formatClassName([" ".concat(className || ''), 'form-modal', "modal-size-".concat(size)]);
  };

  var modalClassName = getModalClasses();
  var dataAttributes = pickDataAttributes(props);
  var modalFooter = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "data-action": "form-cancel",
    isDisabled: disableButtons,
    id: "form-modal-cancel-button",
    onClick: function onClick() {
      var _formRef$current;

      return formRef === null || formRef === void 0 || (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.onCancel();
    },
    variant: "secondary"
  }, cancelButtonText || i18n.t('Cancel')), saveButton && /*#__PURE__*/React.createElement(Button, {
    "data-object-action": "form-save",
    isDisabled: disableButtons || saveButtonDisabled || (formRef === null || formRef === void 0 || (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : _formRef$current2.state.isDisabled),
    id: "form-modal-save-button",
    onClick: function onClick() {
      var _formRef$current3;

      return formRef === null || formRef === void 0 || (_formRef$current3 = formRef.current) === null || _formRef$current3 === void 0 ? void 0 : _formRef$current3.save();
    },
    variant: "primary"
  }, saveButtonIcon, saveButtonText || i18n.t('Save')), saveAndAddButton && /*#__PURE__*/React.createElement(Button, {
    isDisabled: disableButtons,
    "data-object-action": "form-save-and-add",
    id: "form-modal-save-and-add-button",
    onClick: function onClick() {
      var _formRef$current4;

      return formRef === null || formRef === void 0 || (_formRef$current4 = formRef.current) === null || _formRef$current4 === void 0 ? void 0 : _formRef$current4.save(true);
    },
    variant: "primary"
  }, i18n.t('Save and Add Another')));

  var getCoreModalHeader = function getCoreModalHeader() {
    return /*#__PURE__*/React.createElement(Typography, _extends({
      as: "h2"
    }, dataAttributes), title);
  };

  return /*#__PURE__*/React.createElement(Modal, {
    size: size,
    isOpen: show === undefined ? !!data : show,
    modalType: "modal",
    header: getCoreModalHeader(),
    footer: modalFooter,
    className: modalClassName,
    onClose: onHide,
    containerRef: container,
    isCentered: true
  }, buildForm());
};

ModalForm.displayName = "ModalForm";
export { ModalForm };